import { render, staticRenderFns } from "./GerenciamentoPedidos-Aba4.vue?vue&type=template&id=d3f6243a&"
import script from "./GerenciamentoPedidos-Aba4.vue?vue&type=script&lang=js&"
export * from "./GerenciamentoPedidos-Aba4.vue?vue&type=script&lang=js&"
import style0 from "./GerenciamentoPedidos-Aba4.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports